export function toQueryParams(
  params: Record<string, string | number | boolean | null | undefined | string[]>
): string {
  const query = Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(String(value)).replaceAll('%2C', ','); // preserve commas
      return `${encodedKey}=${encodedValue}`;
    })
    .join('&');

  return query ? `?${query}` : '';
}
